import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CreateSaleService } from '../create-sale';
import { map, takeUntil } from 'rxjs/operators';
import { UserService } from '@web-frontend/shared/services';
import { FeatureFlagsService } from '@web-frontend/shared/services/feature-flags/feature-flags.service';
import { Router } from '@angular/router';
import { IDeal } from '@tacliatech/types';
import { Subject } from 'rxjs';

@Component({
  selector: 'charge-deal-modal',
  templateUrl: './charge-deal-modal.component.html',
  styleUrls: ['./charge-deal-modal.component.scss'],
})
export class ChargeDealModalComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  featureFlagSimplified = false;

  constructor(
    public dialogRef: MatDialogRef<ChargeDealModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { deal: IDeal },
    private createSaleService: CreateSaleService,
    private userService: UserService,
    private featureFlags: FeatureFlagsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.featureFlags
      .getValue('show_simplified_invoice', false)
      .then((featureFlag: boolean) => {
        this.featureFlagSimplified = featureFlag;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  exit(): void {
    this.dialogRef.close();
  }

  onInvoice(): void {
    this.exit();
    this.router.navigate(['/admin/documents/create/bill'], {
      queryParams: { fromDealId: this.data.deal._id },
    });
  }

  onSimplified(): void {
    this.exit();
    const isCountryValid = this.userService.validateCountryES();

    if (isCountryValid && this.featureFlagSimplified) {
      this.router.navigate(['/admin/documents/create/simplified'], {
        queryParams: { fromDealId: this.data.deal._id },
      });
      return;
    }

    this.createSaleService
      .open({
        position: { right: '0px' },
        data: {
          mode: 'ADD',
          deal: this.data.deal,
        },
      })
      .pipe(
        map((res) => !res),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }
}
